import React from 'react';
// @ts-ignore
import DraggableTable from '../../../components/DraggableTable';
import LoadingCard from '../../../components/LoadingCard';
import { ProjectListItem } from '../../../types';
import { PROJECT_COLUMNS } from './projectColumns';

interface ProjectsTableProps {
  currentProjects: ProjectListItem[];
  highlightedId: number | null;
  loading: boolean;
  searchQuery: string;
  onView: (id: number) => void;
  onEdit: (id: number) => void;
}

const ProjectsTable: React.FC<ProjectsTableProps> = ({
  currentProjects,
  highlightedId,
  loading,
  searchQuery,
  onView,
  onEdit,
}) => {
  if (loading) {
    return (
      <div className="theme-border rounded-lg overflow-hidden theme-bg-primary p-4">
        <LoadingCard title="JobTRAC" message="Loading projects..." />
      </div>
    );
  }

  return (
    <div className="theme-border rounded-lg overflow-hidden theme-bg-primary1">
      <DraggableTable
        columns={PROJECT_COLUMNS(highlightedId, onView, onEdit)}
        data={currentProjects}
        emptyMessage={searchQuery ? 'No projects found matching your search' : 'No projects'}
      />
    </div>
  );
};

export default ProjectsTable;
